// eslint-disable-next-line no-unused-vars
import Headroom from "headroom.js";
// eslint-disable-next-line no-unused-vars
import lity from "lity";
// eslint-disable-next-line no-unused-vars
import Sticky from "sticky-kit/dist/sticky-kit.js";

export default {
  init() {

    $(document).on(
      "click",
      "header .navbar-toggler",
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        $("body").toggleClass("mm-menu-open");
        $("header #crw-nav-icon").toggleClass("open");
      }
    );

    var options = {
    // or you can specify offset individually for up/down scroll
      offset: 30,
    // scroll tolerance in px before state changes
      tolerance : {
        up: 0,
        down: 0,
      },
    // css classes to apply
    };

    // JavaScript to be fired on all pages
    const scroll_to_top = document.querySelector(".crw-header");
    if ( scroll_to_top ) {
      const headroom = new Headroom(scroll_to_top, options);
      headroom.init();
    }

    // Mobile sidebar navigation
    $(document).on("click", ".crw-sidebar .crw-sidebar-nav", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const nav = $(this);
      const navWidget = $(".crw-sidebar .crw-nav-widget");
      const isOpen = nav.toggleClass("open").hasClass("open");
      navWidget.toggleClass("open", isOpen);
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/common.js